import { RemoteUpdateSemester } from 'data/usecases';
import { makeApiUrlEntitiesSemesters } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdateSemester = (): RemoteUpdateSemester => {
  return new RemoteUpdateSemester(
    makeApiUrlEntitiesSemesters(),
    makeAxiosHttpClient(),
  );
};
